import { render, staticRenderFns } from "./CsimVisitFormItem.vue?vue&type=template&id=718a3dfc"
import script from "./CsimVisitFormItem.vue?vue&type=script&lang=js"
export * from "./CsimVisitFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports